
const environments = {
  development: {
    baseURL: 'https://dev3.hooperlabs.com/bapi',
    hostURL: 'https://dev3.hooperlabs.com',
    basicAuth: 'RlBPVTYxRkFYUTBET0EzRVNFWk06MmNjN2NlMWMtZDBkMi0xMWVhLTg3ZDAtMDI0MmFjMTMwMDAz',
    clientBasicAuth: 'Wk9KMlQ3Q0NVWTk2VFBXSFM0UlM6MmNjN2NlMWMtZDBkMi0xMWVhLTg3ZDAtMDI0MmFjMTMwMDAz',
    angularUrl: 'https://dev3.hooperlabs.com',
    googleAPIKey: "AIzaSyAoAcynRDV7x90Scf36_ReF6ufCOHyJOzs"
  },
  devr: {
    baseURL: 'https://deva-hooperlab.kellton.net/bapi',
    hostURL: 'https://devr.kellton.net',
    basicAuth: "OE5TMjFBT1pRUVRKS0lGTUVIR0M6MmNjN2NlMWMtZDBkMi0xMWVhLTg3ZDAtMDI0MmFjMTMwMDAz",
    clientBasicAuth: "MUhZQVNJQVBWWVA5N1UwSjFSWU46MmNjN2NlMWMtZDBkMi0xMWVhLTg3ZDAtMDI0MmFjMTMwMDAz",
    angularUrl: 'https://deva-hooperlab.kellton.net',
    googleAPIKey: "AIzaSyD9U_9nNBx3SAIv3anAguI8LdAOfSHrufY",
    s3_replace_key: "hooperlabsdev",
    GOOGLE_CLIENT_ID: "113203434260-0rlijsft98d3v1f5uqtpvd4a6jqhkudb.apps.googleusercontent.com",
  },
  staging: {
    baseURL: 'https://stg3.hooperlabs.com/bapi',
    hostURL: 'https://stg4.hooperlabs.com',
    basicAuth: 'OE5TMjFBT1pRUVRKS0lGTUVIR0M6MmNjN2NlMWMtZDBkMi0xMWVhLTg3ZDAtMDI0MmFjMTMwMDAz',
    clientBasicAuth: 'MUhZQVNJQVBWWVA5N1UwSjFSWU46MmNjN2NlMWMtZDBkMi0xMWVhLTg3ZDAtMDI0MmFjMTMwMDAz',
    angularUrl: 'https://stg3.hooperlabs.com',
    googleAPIKey: "AIzaSyB-hB5HngcNdb8OQXTKISYgDpGZGfRHbvA",
  },
  pror: {
    baseURL: 'https://prok.kellton.net/bapi',
    hostURL: 'https://pror.kellton.net',
    basicAuth: "NjBNSDdQUjdYRE5CVzk4N1c3OEg6NTc4MTEwNTgtYjJiMC00MTc5LWEwMjQtNTA4ZTYwZWZjZDE5",
    clientBasicAuth: "",
    angularUrl: 'https://prok.kellton.net',
    googleAPIKey: "AIzaSyBybmjEv8jipBJf9O9umnuNxJi0w90XYew",
    s3_replace_key: "kellton-pro"
  },
  uflex: {
    baseURL: 'https://prok.kellton.net/bapi',
    hostURL: 'https://uflex.kellton.net',
    basicAuth: "NjBNSDdQUjdYRE5CVzk4N1c3OEg6NTc4MTEwNTgtYjJiMC00MTc5LWEwMjQtNTA4ZTYwZWZjZDE5",
    clientBasicAuth: "",
    angularUrl: 'https://prok.kellton.net',
    googleAPIKey: "AIzaSyBybmjEv8jipBJf9O9umnuNxJi0w90XYew",
    s3_replace_key: "kellton-pro"
  },
  tcp: {
    baseURL: 'https://prok.kellton.net/bapi',
    hostURL: 'https://tcp.kellton.net',
    basicAuth: "NjBNSDdQUjdYRE5CVzk4N1c3OEg6NTc4MTEwNTgtYjJiMC00MTc5LWEwMjQtNTA4ZTYwZWZjZDE5",
    clientBasicAuth: "",
    angularUrl: 'https://prok.kellton.net',
    googleAPIKey: "AIzaSyBybmjEv8jipBJf9O9umnuNxJi0w90XYew",
    s3_replace_key: "kellton-pro"
  },
  adani: {
    baseURL: 'https://prok.kellton.net/bapi',
    hostURL: 'https://adani.kellton.net/',
    basicAuth: "NjBNSDdQUjdYRE5CVzk4N1c3OEg6NTc4MTEwNTgtYjJiMC00MTc5LWEwMjQtNTA4ZTYwZWZjZDE5",
    clientBasicAuth: "",
    angularUrl: 'https://prok.kellton.net',
    googleAPIKey: "AIzaSyBybmjEv8jipBJf9O9umnuNxJi0w90XYew",
    s3_replace_key: "kellton-pro"
  },
  tcpehs: {
    baseURL: 'https://prok.kellton.net/bapi',
    hostURL: 'https://tcpehs.kellton.net',
    basicAuth: "NjBNSDdQUjdYRE5CVzk4N1c3OEg6NTc4MTEwNTgtYjJiMC00MTc5LWEwMjQtNTA4ZTYwZWZjZDE5",
    clientBasicAuth: "",
    angularUrl: 'https://prok.kellton.net',
    googleAPIKey: "AIzaSyBybmjEv8jipBJf9O9umnuNxJi0w90XYew",
    s3_replace_key: "kellton-pro"
  },
  omya: {
    baseURL: 'https://prok.kellton.net/bapi',
    hostURL: 'https://omya.kellton.net',
    basicAuth: "NjBNSDdQUjdYRE5CVzk4N1c3OEg6NTc4MTEwNTgtYjJiMC00MTc5LWEwMjQtNTA4ZTYwZWZjZDE5",
    clientBasicAuth: "",
    angularUrl: 'https://prok.kellton.net',
    googleAPIKey: "AIzaSyBybmjEv8jipBJf9O9umnuNxJi0w90XYew",
    s3_replace_key: "kellton-pro"
  },
  tcpsop: {
    baseURL: 'https://prok.kellton.net/bapi',
    hostURL: 'https://tcpsop.kellton.net',
    basicAuth: "NjBNSDdQUjdYRE5CVzk4N1c3OEg6NTc4MTEwNTgtYjJiMC00MTc5LWEwMjQtNTA4ZTYwZWZjZDE5",
    clientBasicAuth: "",
    angularUrl: 'https://prok.kellton.net',
    googleAPIKey: "AIzaSyBybmjEv8jipBJf9O9umnuNxJi0w90XYew",
    s3_replace_key: "kellton-pro"
  },
};

export const getEnvironment = () => {
  const host = window?.location?.host;
  const environment = Object.keys(environments).find((env) => {
    return environments[env].hostURL.includes(host);
  });
  return environment || 'pror';
};

export const getBaseURL = () => {
  const environment = getEnvironment();
  return environments[environment].baseURL;
};

export const getEnvironmentHost = () => {
  const environment = getEnvironment();
  return environments[environment].hostURL;
};

export const getEnvironmentMode = () => {
  const hostURL = getEnvironmentHost();
  switch (true) {
    case hostURL.includes('dev3.hooperlabs.com'):
    case hostURL.includes('dev4.hooperlabs.com'):
      return 'dev';
    case hostURL.includes('stg3.hooperlabs.com'):
    case hostURL.includes('stg4.hooperlabs.com'):
      return 'stage';
    case hostURL.includes('deva-hooperlab.kellton.net'):
    case hostURL.includes('devr.kellton.net'):
      return 'devr';
    case hostURL.includes('pror.kellton.net'):
    case hostURL.includes('prok.kellton.net'):
      return 'pror';
    case hostURL.includes('pro.hooperlabs.com'):
      return 'pro';
    case hostURL.includes('tcp.kellton.net'):
      return 'tcp';
    case hostURL.includes('tcpehs.kellton.net'):
      return 'tcpehs';
    case hostURL.includes('uflex.kellton.net'):
      return 'uflex';
    case hostURL.includes('adani.kellton.net'):
      return 'adani';
    case hostURL.includes('omya.kellton.net'):
      return 'omya';
    case hostURL.includes('tcpsop.kellton.net'):
      return 'tcpsop';
    default:
      return 'dev';
  }
};

export const getBasicAuth = () => {
  const environment = getEnvironment();
  return environments[environment].basicAuth;
};

export const getClientBasicAuth = () => {
  const environment = getEnvironment();
  return environments[environment].clientBasicAuth;
};

export const getGoogleAPIKey = () => {
  const environment = getEnvironment();
  return environments[environment].googleAPIKey;
};

export const getS3ReplaceBucketKey = () => {
  const environment = getEnvironment();
  return environments[environment]?.s3_replace_key || 'hooperlabs';
};

export const getAngularURL = () => {
  const environment = getEnvironment();
  return environments[environment].angularUrl;
};

export const getGoogleClientID = () => {
  const environment = getEnvironment();
  return environments[environment].GOOGLE_CLIENT_ID;
};

export const getGoogleCallbackURL = () => {
  const originUrl = window?.location?.origin;
  return `${originUrl}/google/callback`;
};
